import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, FctValue16 } from '../../../../Fct/generics';
import { getRadiantV2Tokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { LENDING_POOL_ADDRESSES, R_TOKENS } from '../constants';
export var Borrow = createPlugin({
    protocol: 'RADIANTV2',
    type: 'ACTION',
    method: 'borrow',
    supportedContracts: LENDING_POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'radiant_lending_pool_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getRadiantV2Tokens({ chainId: chainId }) }),
                    amount: new FctValue({ destination: 'wei_amount' }),
                    interestRateMode: new FctValue({ options: [{ value: '1' }, { value: '2' }] }),
                    referralCode: new FctValue16({}),
                    onBehalfOf: new FctAddress({}),
                },
            },
            output: {},
        });
    },
    initParams: {
        methodParams: {
            referralCode: '0',
        },
    },
    requiredApprovals: function (params, chainId, _walletAddress, vaultAddress) {
        var _a = params.methodParams, amount = _a.amount, onBehalfOf = _a.onBehalfOf, asset = _a.asset;
        var assetValue = asset.value;
        if (assetValue && typeof assetValue != 'string') {
            return [];
        }
        var fromTokenData = R_TOKENS[chainId].find(function (token) { return token.underlying.toLowerCase() === assetValue.toLowerCase(); });
        if (!fromTokenData) {
            return [];
        }
        if (!vaultAddress)
            return [];
        var value;
        if (typeof amount.value === 'string') {
            value = amount.value;
        }
        if (!value && typeof amount.estimatedValue === 'string') {
            value = amount.estimatedValue;
        }
        if (!value)
            return [];
        return [
            {
                to: fromTokenData.address,
                from: onBehalfOf.value,
                params: { delegatee: vaultAddress, amount: value },
                method: 'approveDelegation',
                protocol: 'RADIANTV2',
            },
        ];
    },
});
